import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["_expressCheckoutButtonsData"];
import React from 'react';
import { ExpressCheckoutButtonsContext } from './ExpressCheckoutButtonsContext';
import { withFunctionObservationResult } from '@wix/function-result-observation';
import { RESULT_PROP_NAME } from '../utils/consts';
export function withExpressCheckoutButtons(Component) {
  return withFunctionObservationResult(props => {
    const _ref = props,
      _expressCheckoutButtonsData = _ref._expressCheckoutButtonsData,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/React.createElement(ExpressCheckoutButtonsContext.Provider, {
      value: _expressCheckoutButtonsData
    }, /*#__PURE__*/React.createElement(Component, otherProps));
  }, {
    resultPropName: RESULT_PROP_NAME
  });
}
//# sourceMappingURL=withExpressCheckoutButtons.js.map